import { render, staticRenderFns } from "./device-edit.vue?vue&type=template&id=844d5c34&"
import script from "./device-edit.vue?vue&type=script&lang=js&"
export * from "./device-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844d5c34')) {
      api.createRecord('844d5c34', component.options)
    } else {
      api.reload('844d5c34', component.options)
    }
    module.hot.accept("./device-edit.vue?vue&type=template&id=844d5c34&", function () {
      api.rerender('844d5c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/device-list/device-edit.vue"
export default component.exports